import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepresentiveContactsComponent } from './representive-contacts.component';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [RepresentiveContactsComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule],
  exports: [RepresentiveContactsComponent],
})
export class RepresentiveContactsModule {}
